<template>
  <div style="height: 100%">
    <a-row :gutter="20" >
      <a-col :span="3">
        <a-menu
          v-model="selectedKeys"
          mode="inline"
          @click="handleClick"
        >
          <a-menu-item :key="sysUser.id" v-for="sysUser in personList">{{sysUser.realname +'('+sysUser.username+')'}}</a-menu-item>
        </a-menu>
        <a-modal
          title="请选择重新分配的采集员"
          :width="800"
          :visible="visible"
          :confirmLoading="loading"
          switchFullscreen
          @ok="releaseAssignmentSubmit"
          @cancel="releaseAssignmentCancel"
          cancelText="关闭">
          <a-checkbox-group v-model="personIds" style="width: 100%" >
            <a-row>
              <template v-for="(sysUser,index) in personList">
                <a-col :span="8"  :key="index" v-if="parentBaseQueryParam.assignmentPersonId != sysUser.id">
                  <a-checkbox :value="sysUser.id">
                    {{sysUser.realname +'('+sysUser.username+')'}}
                  </a-checkbox>
                </a-col>
              </template>
            </a-row>
          </a-checkbox-group>
        </a-modal>
      </a-col>
      <a-col :span="20">
        <patient-index ref="patientIndex" v-if="parentBaseQueryParam.assignmentPersonId" :parentBaseQueryParam="parentBaseQueryParam" @handleView="handleSelect" :isRegister="false" :isPeriod="true">
        <span slot="btn">
          <a-button type="primary" @click="releaseAssignment" :loading="loading" >释放当前采集员的任务分配</a-button>
        </span>
        </patient-index>
      </a-col>
    </a-row>
  </div>
</template>

<script>
  import PatientIndex from './components/register/PatientIndex'
  import { getAction,postAction } from '@/api/manage'
  import { CACHE_PROJECT_ID} from '@/constants/project'
  import Vue from 'vue'

  export default {
    name: 'PatientPeriod',
    components: { PatientIndex },
    data(){
      return {
        projectId: Vue.ls.get(CACHE_PROJECT_ID),
        parentBaseQueryParam:{},
        selectedKeys:[],
        personList : [],
        visible:false,
        loading:false,
        personIds:[],
      }
    },
    mounted(){
      getAction('/project/projectUser/getAssignmentUser',{projectId:this.projectId}).then(res=>{
        if(res.success){
          this.personList = res.result
          if(this.personList.length>0){
            this.selectedKeys = [this.personList[0].id]
            this.handleClick()
          }
        }
      })
    },
    methods:{
      handleSelect(record){
        this.$router.push({path:'/project/patient/registerview/'+record.id})
      },
      handleClick(){
        this.$nextTick(()=>{
          if(this.selectedKeys.length===0 ){
            return
          }
          if(this.selectedKeys[0]===this.parentBaseQueryParam.assignmentPersonId ){
            return
          }
          this.parentBaseQueryParam = {assignmentPersonId:this.selectedKeys[0]}
          // this.$message.success(this.selectedKeys[0])
        })
      },
      releaseAssignmentCancel(){
        this.personIds = []
        this.visible = false
      },
      releaseAssignment(){
        this.$confirm({
          title: '释放采集员的任务',
          content: '是否确认释放采集员的任务？',
          onOk:()=> {
            this.visible = true
          },
        });
      },
      releaseAssignmentSubmit(){
        this.loading = true
        postAction('/assignment/patientAssignment/release',{personId:this.parentBaseQueryParam.assignmentPersonId,projectId:this.projectId,personIds:this.personIds}).then(res=>{
          if(res.success){
            this.$refs.patientIndex.loadData();
            this.visible = false
          }
        }).finally(()=>{
          this.loading = false
        })

      },
    }
  }
</script>

<style scoped>

</style>